import { configureStore } from '@reduxjs/toolkit';

import { actionBarMiddleware } from './action-bar/actionBarMiddleware.ts';
import { cellSelectionsNoOpMiddleware } from './cellSelections/noOpMiddleware.ts';
import { presenceMiddleware } from './presence/presenceMiddleware.ts';
import { defaultReducers, getAppStoreUtils } from './redux.ts';
import { type AppRootState } from './types.ts';

export const appStore = configureStore({
  reducer: {
    ...defaultReducers
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(
      presenceMiddleware.middleware,
      actionBarMiddleware.middleware,
      cellSelectionsNoOpMiddleware
    )
});

export type { AppRootState } from './types.ts';
export const appStoreUtils = getAppStoreUtils<AppRootState>();
